import { render, staticRenderFns } from "./money2.vue?vue&type=template&id=dcd4b128&scoped=true&"
import script from "./money2.vue?vue&type=script&lang=js&"
export * from "./money2.vue?vue&type=script&lang=js&"
import style0 from "./money2.vue?vue&type=style&index=0&id=dcd4b128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd4b128",
  null
  
)

export default component.exports